import { useEffect, useMemo, useState } from "react";
import { ChartFilterBar, HorizontalStackedBarChartCard } from "../../../components/Charts";
import type { FilterDefinition, FilterValues } from "../../../types/chartFilters";
import type { FilterOnChange } from "../../../components/Charts/ChartFilterBar";
import { useP4Data, type P4FilterValues } from "./useP4ChartData";
import CompareButton from "../common/CompareButton";

const DEFAULT_FILTERS: P4FilterValues = { titulacions: [] };
const DEFAULT_COUNT = 5;

const P4ChartSection = () => {
  const [filters, setFilters] = useState<P4FilterValues>(DEFAULT_FILTERS);
  const { chartData, bars, availableTitulacions, loading, error } =
    useP4Data(filters);

  const [defaultsApplied, setDefaultsApplied] = useState(false);

  useEffect(() => {
    if (!defaultsApplied && availableTitulacions.length > 0) {
      setFilters((prev) => ({
        ...prev,
        titulacions: availableTitulacions.slice(0, DEFAULT_COUNT),
      }));
      setDefaultsApplied(true);
    }
  }, [availableTitulacions, defaultsApplied]);

  const titulacioOptions = useMemo(
    () => availableTitulacions.map((t) => ({ value: t, label: t })),
    [availableTitulacions]
  );

  const p4Filters: FilterDefinition[] = useMemo(
    () => [
      {
        type:        "multiSelect",
        key:         "titulacions",
        label:       "Titulació",
        options:     titulacioOptions,
        placeholder: "Titulació",
      },
    ],
    [titulacioOptions]
  );

  const handleFilterChange: FilterOnChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value } as P4FilterValues));
  };

  return (
    <>
      <ChartFilterBar
        filters={p4Filters}
        values={filters as unknown as FilterValues}
        onChange={handleFilterChange}
        disabled={loading}
      />
      <HorizontalStackedBarChartCard
        title="Índex de desajust laboral per titulació"
        data={chartData}
        yKey="nom_titulacio"
        bars={bars}
        loading={loading}
        error={error}
        xDomain={[0, 1]}
        tooltipSuffix=""
        stacked={false}
        labelMinThreshold={0}
      />
      <CompareButton />
    </>
  );
};

export default P4ChartSection;
